export default __webpack_public_path__ + "static/media/undo.8ff2ef4b.svg";